import * as React from "react"
import {CommandCaller} from "../../lib/commands";
import * as ReactDOM from "react-dom";
import {OwnProps, QueryFormModalApp, QueryFormStore} from "./query-form/app";
import {applyMiddleware, createStore} from "redux";
import {withDefault} from "../../lib/utils";
import {reducer, State} from "./query-form/reducers";
import thunkMiddleware from "redux-thunk"
import {CategoryTreeItem} from "../../lib/category-manager/data";

type QueryDataCommand = 'my queries'|'shared queries'
type QueryGrid = 'myQueriesDataGrid'|'sharedQueriesDataGrid'

type GetQueryDataProps = {
	ajaxPageUrl:string
	command:QueryDataCommand
	categoryId:number
}

export const getQueriesGridData = (props:GetQueryDataProps) => {
	console.log(props);
	return (callback:(_:string) => void) => {
		const cc = new CommandCaller(props.ajaxPageUrl)
		cc.runGet(props.command, {categoryId: props.categoryId}).then(
			(response) => { callback((response as {content:string}).content) }
		)
	}
}

type DeleteQueriesProps = {
	ajaxPageUrl:string
	grid:QueryGrid
}

export const deleteQueries = (props:DeleteQueriesProps) => {
	return (ids:string) => {
		const pluralQueries = ids.split(',').length > 1 ? 'queries' : 'query'
		if(confirm(`Are you sure you want to permanently delete the selected ${pluralQueries}?`)) {
			const cc = new CommandCaller(props.ajaxPageUrl);
			cc.runPost('delete queries', {ids: ids}).then(
				() => { new HtmlDataGrid(props.grid).refresh() }
			)
		}
	}
}

type QueryFormProps = {
	ajaxPageUrl: string
	datagridId?: string
	queryId?: string|number
	title?: string
	selectedCategories?: (string|number)[]
}

export const queryForm = async (props: QueryFormProps) => {
	const sc = await new CommandCaller(props.ajaxPageUrl).runGet(
		'get category tree data'
	) as {categories: CategoryTreeItem[]}

	const ownProps = (store: QueryFormStore): OwnProps => ({
		store: store,
		ajaxPageUrl: props.ajaxPageUrl,
		onClose: () => {
			ReactDOM.unmountComponentAtNode(div)
			if(props.datagridId !== undefined) {
				new HtmlDataGrid(props.datagridId).refresh();
			}
		},
		categories: sc.categories
	})

	const initialState: State = {
		queryId: props.queryId !== undefined ? props.queryId : 0,
		title: props.title !== undefined ? props.title : '',
		submitting: false,
		errorFields: [],
		categoryManagerState: {
			selectedCategories: props.selectedCategories !== undefined ? props.selectedCategories : []
		}
	}

	const div = document.createElement('div');
	const body = document.getElementsByTagName('body')[0];
	body.appendChild(div);

	const store = createStore(withDefault(reducer, initialState), initialState, applyMiddleware(thunkMiddleware))
	ReactDOM.render(<QueryFormModalApp {...ownProps(store)}/>, div)
}



// WEBPACK FOOTER //
// ./src/contacts/saved-queries/saved-queries.tsx